import type { HandleClientError } from '@sveltejs/kit/hooks';
import * as Sentry from '@sentry/sveltekit';
import { handleErrorWithSentry } from '@sentry/sveltekit';
import { getLogger } from '@logtape/logtape';
import '#lib/logger.js';
import {
	sentryEnabled,
	sentryDsn,
	sentryEnvironment,
	sentryRelease,
	sentryTracesSampleRate,
	sentryProfileSessionSampleRate,
	sentryIgnoreErrors,
	sentryIgnoredRequestUrls,
	sentryTracePropagationEnabled,
	sentryTracePropagationTargets
} from '#lib/sentryConfig.js';

const log = getLogger(['platform', 'hooks', 'client']);

if (sentryEnabled && sentryDsn) {
	Sentry.init({
		dsn: sentryDsn,
		environment: sentryEnvironment,
		release: sentryRelease,
		tracesSampleRate: sentryTracesSampleRate,
		profileSessionSampleRate: sentryProfileSessionSampleRate,
		profileLifecycle: 'trace',
		ignoreErrors: sentryIgnoreErrors,
		...(sentryTracePropagationEnabled && {
			tracePropagationTargets: sentryTracePropagationTargets
		}),
		integrations: [
			Sentry.browserTracingIntegration({
				shouldCreateSpanForRequest: (url) =>
					sentryIgnoredRequestUrls.every((pattern) => !url.includes(pattern))
			}),
			Sentry.browserProfilingIntegration()
		],
		initialScope: { tags: { runtime: 'client' } }
	});
}

export const handleError: HandleClientError = sentryEnabled
	? handleErrorWithSentry()
	: ({ error, kind }) => {
			// SvelteKit 3 also routes expected errors (e.g. `error(404)`) here; only unexpected ones are logged.
			if (kind === 'unknown') log.error('Unhandled client error: {error}', { error });
		};
